export enum MapActionTypeEnum {
  moveToRegular = "regular",
  moveToDelayed = "delayed",
  moveToSkipped = "skipped",
  moveAddresses = "route",
  reverseSequence = "reverse",
  markAsToBePlowed = "toBePlowed",
  markAsCompleted = "completed",
  markAsPartiallyCompleted = "partiallyCompleted",
  markAsCantPlow = "cantPlow",
  sendNotification = "sendNotification",
  // moveToEligible = "moveToEligible",
}

export const mapActionTypeEnumValues = Object.values(MapActionTypeEnum);
export const mapActionTypeEnumLabelMap: Record<MapActionTypeEnum, string> = {
  [MapActionTypeEnum.moveToRegular]: "Move to Regular",
  [MapActionTypeEnum.moveToDelayed]: "Move to Delayed",
  [MapActionTypeEnum.moveToSkipped]: "Move to Skipped",
  [MapActionTypeEnum.moveAddresses]: "Move Addresses",
  [MapActionTypeEnum.reverseSequence]: "Reverse Sequence",
  [MapActionTypeEnum.markAsToBePlowed]: "Mark as To Be Plowed",
  [MapActionTypeEnum.markAsCompleted]: "Mark as Completed",
  [MapActionTypeEnum.markAsPartiallyCompleted]: "Mark as Partially Completed",
  [MapActionTypeEnum.markAsCantPlow]: "Mark as Can't Plow",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};

export const mapActionTypeEnumTooltipMap: Partial<
  Record<MapActionTypeEnum, string>
> = {
  [MapActionTypeEnum.sendNotification]: "Send a message to selected recipients",
};

export const livePhaseMapActionTypeEnum: Partial<
  Record<MapActionTypeEnum, string>
> = {
  [MapActionTypeEnum.moveAddresses]: "Move Addresses",
  [MapActionTypeEnum.reverseSequence]: "Reverse Sequence",
  [MapActionTypeEnum.markAsToBePlowed]: "Mark as To Be Plowed",
  [MapActionTypeEnum.markAsCompleted]: "Mark as Completed",
  [MapActionTypeEnum.markAsPartiallyCompleted]: "Mark as Partially Completed",
  [MapActionTypeEnum.markAsCantPlow]: "Mark as Can't Plow",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};

export const endedPhaseMapActionTypeEnum: Partial<
  Record<MapActionTypeEnum, string>
> = {
  [MapActionTypeEnum.markAsCompleted]: "Mark as Completed",
  [MapActionTypeEnum.markAsPartiallyCompleted]: "Mark as Partially Completed",
  [MapActionTypeEnum.markAsCantPlow]: "Mark as Can't Plow",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};

export const buildPhaseMapActionTypeEnum: Partial<
  Record<MapActionTypeEnum, string>
> = {
  [MapActionTypeEnum.moveAddresses]: "Move Addresses",
  [MapActionTypeEnum.reverseSequence]: "Reverse Sequence",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};

export const planPhaseMapActionTypeEnum: Partial<
  Record<MapActionTypeEnum, string>
> = {
  [MapActionTypeEnum.moveToRegular]: "Move to Regular",
  [MapActionTypeEnum.moveToDelayed]: "Move to Delayed",
  [MapActionTypeEnum.moveToSkipped]: "Move to Skipped",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};

export const mapActionRouteTypeSelectOptions = mapActionTypeEnumValues.map(
  (c) => ({
    label: mapActionTypeEnumLabelMap[c],
    value: c,
    tooltip: mapActionTypeEnumTooltipMap[c],
  }),
);

export const livePhaseRouteTypeSelectOptions = Object.entries(
  livePhaseMapActionTypeEnum,
).map(([c, label]) => ({
  label: label as string,
  value: c as MapActionTypeEnum,
  tooltip: mapActionTypeEnumTooltipMap[c as MapActionTypeEnum],
}));

export const endedPhaseRouteTypeSelectOptions = Object.entries(
  endedPhaseMapActionTypeEnum,
).map(([c, label]) => ({
  label: label as string,
  value: c as MapActionTypeEnum,
  tooltip: mapActionTypeEnumTooltipMap[c as MapActionTypeEnum],
}));

export const buildPhaseRouteTypeSelectOptions = Object.entries(
  buildPhaseMapActionTypeEnum,
).map(([c, label]) => ({
  label: label as string,
  value: c as MapActionTypeEnum,
  tooltip: mapActionTypeEnumTooltipMap[c as MapActionTypeEnum],
}));

export const planPhaseRouteTypeSelectOptions = Object.entries(
  planPhaseMapActionTypeEnum,
).map(([c, label]) => ({
  label: label as string,
  value: c as MapActionTypeEnum,
  tooltip: mapActionTypeEnumTooltipMap[c as MapActionTypeEnum],
}));
